import { Component, inject, OnInit } from '@angular/core';
import { AdminSubcategoriesList } from '../../../../components/admin-dashboard-component/subcategories/admin-subcategories-list/admin-subcategories-list';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-admin-list-subcategories',
  imports: [AdminSubcategoriesList, CommonModule, RouterLink],
  templateUrl: './admin-list-subcategories.html',
  styleUrl: './admin-list-subcategories.scss',
})
export class AdminListSubcategories implements OnInit {
  route = inject(ActivatedRoute);
  companyId: string | null = null;
  ngOnInit() {
    this.companyId = this.route.snapshot.paramMap.get('id');
  }
}
